<template>
  <div>
    <b-row>
      <b-col>
        <h1 variant="primary">Please Scan Product</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group label label-for="barCodeInput">
          <b-form-input
            id="barCodeInput"
            ref="barCodeInput"
            v-model="barCode"
            v-on:keyup.enter="processScannedProduct"
            autofocus
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <div>
      <b-modal
        ref="modalVariablePriceQty"
        title="Variable Price and Quantity"
        hide-footer
        no-enforce-focus
        no-close-on-backdrop
        centered
        size="lg"
      >
        <variable-prd-price-modal  @success="acceptVariablePriceQty" @cancel="cancelVariablePriceQty" :product="variablePriceProduct" />
      </b-modal>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VariablePrdPriceModal from "./VariablePrdPriceModal";

export default {
  name: "ScanBarcodeProduct",
  props: {
    systemid: {
      type: String,
      default: '',
    }
  },
  components: {
    "variable-prd-price-modal": VariablePrdPriceModal
  },
  data: function() {
    return {
      barCode: "",
      variablePriceProduct: null
    }
  },
  methods: {
    focus() {
      this.$refs.barCodeInput.focus();
      console.log("Focus Called");
    },
    acceptVariablePriceQty(product) {
      this.$refs.modalVariablePriceQty.hide();
      const selectedProduct = JSON.parse(JSON.stringify(product));
      this.variablePriceProduct = null;
      this.barCode = "";
      this.$emit("found-product", selectedProduct);
    },
    cancelVariablePriceQty() {
      this.$refs.modalVariablePriceQty.hide();
      this.variablePriceProduct = null;

    },
    processScannedProduct() {

      if(this.barCode != null && this.barCode.length > 0){
          console.log('setting params')
        let params = {
          systemid: this.systemid,
          barcode: this.barCode
        }
        this.$store.dispatch('pos/searchProductByBarcode', params)
        .then(response => {
          if (response.data.success == false) {
            this.showErrorMsg({
              message: response.data.error
            })
          } else {
            const foundProduct = JSON.parse(JSON.stringify(response.data.data.data));
            if(Object.keys(foundProduct).length > 0){
              if(foundProduct.isvariable == true){
                this.variablePriceProduct = JSON.parse(JSON.stringify(foundProduct));
                this.$refs.modalVariablePriceQty.show();
              }
              else{
                this.barCode = "";
                this.$emit("found-product", JSON.parse(JSON.stringify(foundProduct)));
              }
            }
            else {
              this.showSuccessMsg({
                message: 'No Product Found with Scanned Barcode.'
              });
            }
          }
        })
        .catch(error => {
          if (error.response.status == 400) {
            this.showErrorMsg({
              message: error.response.data.message
            })
          } else if (error.response.status == 422) {
            this.showErrorMsg({
              message: error.response.data.message
            })
          } else {
            this.showErrorMsg({ message: 'Something went wrong. Please contact administrator.' })
          }        });
      }
    }
  }
};
</script>
